import axios from "axios";
import {makeHttpEndpoint} from "./index";

export const getAnswerOptionsForSurvey = async(id: string) => {
    return await axios.get(makeHttpEndpoint(`/answeroptions/${id}`), {withCredentials: true})
}